import { InputMask } from "@react-input/mask";
import FieldValidationError from "../Forms/Element/FieldValidationError";

const ZipCodeInput = (props) => {

    return (
        <>
            <InputMask
                mask="_____-___"
                replacement={{ _: /\d/ }}
                className="form-control input-default"
                {...props}
            />
            <FieldValidationError error={props.error} />
        </>
    )
}

export default ZipCodeInput;